define('lib/audio/create-localized-country',['require','i18next'],function (require) {
    var i18n = require('i18next');

    return function (countryCode) {
        if (countryCode) {
            return {
                country: countryCode,
                displayCountry: i18n.t('countries.' + countryCode)
            };
        }
        return undefined;
    };
});

